import InformationCircle from '@ingka/ssr-icon/paths/information-circle';
import { useIntl } from 'react-intl';
import { showMountingRailSheet } from 'rangeConfig/boaxel/features/MountingRailInfo/MountingRailInfo';
import { useAppDispatch } from 'ducks/hooks';

import SkapaInlineMessage, { InlineMessageVariantEnum } from 'ui/InlineMessage/SkapaInlineMessage';
import SkapaHyperLink from '@ingka/hyperlink';
import { useBehaviorTracker } from 'contexts/behaviors';

const MountingRailInfoMessage = () => {
  const { formatMessage } = useIntl();
  const dispatch = useAppDispatch();
  const behaviorTracker = useBehaviorTracker();

  const openMountingRailInfoSheet = () =>
    behaviorTracker.custom(() => dispatch(showMountingRailSheet()));

  const onClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    openMountingRailInfoSheet();
  };

  return (
    <SkapaInlineMessage
      variant={InlineMessageVariantEnum.INFORMATIVE}
      ssrIcon={InformationCircle}
      subtle
      body={
        <SkapaHyperLink
          button
          subtle
          text={formatMessage({ id: 'storageone.mountingRailInfoTitle' })}
          onClick={onClick}
        />
      }
    />
  );
};

export default MountingRailInfoMessage;
